var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9087 2C19.0527 2 21.1647 4.153 21.1647 7.357V16.553C21.1647 19.785 19.1177 21.887 15.9497 21.907L8.2567 21.91C5.1127 21.91 2.9997 19.757 2.9997 16.553V7.357C2.9997 4.124 5.0467 2.023 8.2147 2.004L15.9077 2H15.9087ZM15.9087 3.5L8.2197 3.504C5.8917 3.518 4.4997 4.958 4.4997 7.357V16.553C4.4997 18.968 5.9047 20.41 8.2557 20.41L15.9447 20.407C18.2727 20.393 19.6647 18.951 19.6647 16.553V7.357C19.6647 4.942 18.2607 3.5 15.9087 3.5ZM15.7158 15.4737C16.1298 15.4737 16.4658 15.8097 16.4658 16.2237C16.4658 16.6377 16.1298 16.9737 15.7158 16.9737H8.4958C8.0818 16.9737 7.7458 16.6377 7.7458 16.2237C7.7458 15.8097 8.0818 15.4737 8.4958 15.4737H15.7158ZM15.7158 11.2872C16.1298 11.2872 16.4658 11.6232 16.4658 12.0372C16.4658 12.4512 16.1298 12.7872 15.7158 12.7872H8.4958C8.0818 12.7872 7.7458 12.4512 7.7458 12.0372C7.7458 11.6232 8.0818 11.2872 8.4958 11.2872H15.7158ZM11.2505 7.1104C11.6645 7.1104 12.0005 7.4464 12.0005 7.8604C12.0005 8.2744 11.6645 8.6104 11.2505 8.6104H8.4955C8.0815 8.6104 7.7455 8.2744 7.7455 7.8604C7.7455 7.4464 8.0815 7.1104 8.4955 7.1104H11.2505Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.ef803a41799ebc5d3daf8ae6a516b030.svg";
export { ForwardRef as ReactComponent };